import routerOptions0 from "/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}